<template>
  <div class="logistics-order">
    <MainBackButton />
    <LogisticsOrderPanel :order="order" />

    <p class="header has-text-left" @click="init">
      <span class="title is-5 has-text-link" style>
        <span class="has-text-black">{{ $t("logistics.logistics") }}</span>
        &nbsp;{{ $t("order") }}
      </span>
    </p>

    <!-- <p class="button is-white is-rounded share" @click="shareOrder">
      <i class="fa fa-paper-plane has-text-link" />
    </p>-->

    <div class="top-right">
      <p
        class="button is-white is-rounded bullseye-btn"
        @click="locate"
        :disabled="zooming"
      >
        <span class="icon bullseye wiggle" :class="{ 'fa-spin': zooming }" />
      </p>
      <p class="button is-white is-rounded wiggle">
        <span class="icon" @click="toggleVehicle">
          <img :src="icon" />
        </span>
      </p>
    </div>

    <div class="map-wrapper">
      <div :id="mapID" class="map" />
    </div>
  </div>
</template>


<script>
// import EventBus from "../eventBus";
import L from "leaflet";
import "leaflet.locatecontrol";
import "leaflet.awesome-markers";
// import "leaflet.marker.slideto";
// import "leaflet-edgebuffer";

import MainBackButton from "@/components/MainBackButton";
import LogisticsOrderPanel from "@/components/LogisticsOrderPanel.vue";
import geo from "@/geo";
import vehicles from "@/vehicles";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "LogisticsOrder",
  components: {
    MainBackButton,
    LogisticsOrderPanel,
  },
  data() {
    return {
      order: null,
      mapID: "logistics-order-map",
      hasGeolocation: true,
      zooming: false,
      showFleet: false,
      locateControl: undefined,
      locateToggle: false, //true,
      map: undefined,
      stateLayer: null,
      userMarker: null,
      driverMarker: null,
      driversMarkers: [], // drivers for observers, all active drivers for workflow
      popupNarrow: { closeButton: false, maxWidth: 100, autoPan: false },
      popupWide: { closeButton: false, maxWidth: 300, autoPan: false },
      dashLine: {
        color: "blue",
        weight: "1",
        dashArray: "5, 5",
        lineCap: "square",
      },
      lineOpt: {
        color: "yellow",
        weight: "2",
        dashArray: "2, 4",
      },
    };
  },
  computed: {
    icon() {
      if (!this.order) return vehicles.img("Balloon");
      return vehicles.img(this.order.workflow.data.icon);
    },
  },
  mounted() {
    this.initMap();
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      var id = this.$route.params.id; // this.console(`LogisticsOrder this.$route ${id}`, this.$route);
      this.getLogisticsOrder(id);
    },
    getLogisticsOrder(id) {
      this.order = null;
      this.$store
        .dispatch("getLogisticsOrder", id)
        .then((res) => this.updateOrder(res.data))
        .catch((err) => this.apiError(err));
    },
    toggleVehicle() {
      if (!this.driverMarker) {
        var msg = "Vehicle will appear 1 hour before pickup";
        return this.warningToast(msg, "top");
      }
      if (this.driverMarker.show) {
        this.infoToast("Hide vehicle", "bottom");
        this.stateLayer.removeLayer(this.driverMarker);
        this.driverMarker.show = false;
      } else {
        this.successToast("Show vehicle", "bottom");
        this.stateLayer.addLayer(this.driverMarker);
        this.driverMarker.show = true;
      }
      this.locate();
    },
    updateOrder(data) {
      if (!data) return this.warningAlert("No order data!"); // will error before
      this.order = data;
      this.clearMap();
      this.drawMarkers();
      this.fitToLayer(this.stateLayer);
      this.locate();
    },
    clearMap() {
      if (this.stateLayer) this.stateLayer.clearLayers();
    },
    drawMarkers() {
      var o = this.order;
      this.drawPickup(o.data.pickup_stop);
      this.drawDropoff(o.data.dropoff_stop);
      this.drawVehicle(o.driver);
    },
    drawVehicle(v) {
      if (!v) return alert("no driver");
      var driver = L.divIcon({
        html: `<div class='driver-circle cyan-bg'><img class='driver-big' src=${this.icon} /></div>`,
        popupAnchor: [-6, -28],
        className: "none",
      });
      var icon = { icon: driver };
      var coords = v.user_state;
      this.driverMarker = L.marker(coords, icon).addTo(this.stateLayer);
      this.driverMarker.show = true;

      var profPic = this.profPic(v);
      var img = `<img src=${profPic} height="100px" width="100px" />`;
      var driverName = v.name;
      var driverText = this.$t("driver.driver");
      var content = `<div style="width:90px">${img}<center><strong>${driverName}</strong><br>${driverText}</center></div>`;
      this.driverMarker.bindPopup(content, this.popupNarrow);
    },
    drawDropoff(s) {
      console.log("drawDropoff", s);
      var dropoffPoint = this.$t("transport.dropoff-point");
      var text = `<strong>${s.name}</strong><br>${dropoffPoint}`;
      var dot = L.divIcon({
        html: `<div class='dropoff-point'></div>`, // yellow dot
        popupAnchor: [4, -7],
        className: "none",
      });
      var icon = { icon: dot };
      var m = L.marker([s.lat, s.lon], icon).addTo(this.stateLayer);
      m.bindPopup(text, this.popupWide);
    },
    drawPickup(s) {
      console.log("drawPickup", s);
      var pickupPoint = this.$t("transport.pickup-point");
      var text = `<strong>${s.name}</strong><br>${pickupPoint}`;
      var dot = L.divIcon({
        html: `<div class='pickup-point'></div>`, // yellow dot
        popupAnchor: [4, -7],
        className: "none",
      });
      var icon = { icon: dot };
      var m = L.marker([s.lat, s.lon], icon).addTo(this.stateLayer);
      m.bindPopup(text, this.popupWide);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps
      var initialLocation = [13.73114, 100.57529]; // default: Bangkok, Soi 41
      //   if (this.$store.getters.getUserLocation) {
      //     initialLocation = this.$store.getters.getUserLocation;
      //   }
      var mapOptions = { attributionControl: false, doubleClickZoom: true };
      this.map = L.map(this.mapID, mapOptions).setView(initialLocation, 17); // set zoom level
      this.map.removeControl(this.map.zoomControl);
      L.tileLayer(tilesURL, {
        // edgeBufferTiles: 1,
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 2,
        maxZoom: 18,
      }).addTo(this.map);
      this.stateLayer = L.featureGroup().addTo(this.map);
      this.map.on("zoomend", () => (this.zooming = false));
      this.map.on("moveend", () => (this.zooming = false));
    },
    locate() {
      if (this.zooming) return; // don't do anything if already zooming
      this.zooming = true;
      setTimeout(() => (this.zooming = false), 3000); // fallback
      this.fitToLayer(this.stateLayer);
    },

    fitToLayer(layer) {
      if (!layer || layer.getLayers().length === 0) return; // (this.zooming = false);
      var opts = { padding: [50, 50] }; // pixels not meters
      try {
        var dist = 0;
        if (layer.getBounds()) {
          var newCenter = layer.getBounds().getCenter();
          dist = geo.distance(newCenter, this.map.getCenter());
        }
        if (dist > 1000) this.map.fitBounds(layer.getBounds(), opts);
        else this.map.flyToBounds(layer.getBounds(), opts);
      } catch (err) {
        console.error("fitToLayer error", err);
        this.map.setView(this.userMarker.getLatLng(), 14);
        this.map.zoomIn();
      }
    },
    shareOrder() {
      this.infoToast("Share Order", "top");
      if (!navigator.share) {
        var txt = `Sharing not supported by this device.<br><br>Send as SMS or paste into a chat.`;
        this.warningAlert(txt);
        return;
      }
      navigator
        .share({
          text: this.$t("delivery.share-message"), //"TUK Delivery📦 Click link to confirm delivery details!🍱🥂",
          url: "tukapp.co/logistics_jobs", //this.shortLink(o)
        })
        .then(() => console.log("Successful share"))
        .catch((err) => console.log("Error sharing", err));
    },
  },
};
</script>


<style scoped>
.map-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
}
.map {
  height: calc(100vh - 250px);
  width: 100vw;
  z-index: 0;
}
.header {
  position: absolute;
  padding-top: 15px;
  margin-bottom: 2px;
  z-index: 1;
}
.header .title {
  margin-left: 55px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 4px;
  border-radius: 8px;
  box-shadow: 1px 1px 2px grey;
}
.top-right {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.top-right p {
  margin: 10px;
  display: block;
  padding: 5px 12.5px;
  filter: drop-shadow(2px 2px 2px #666);
}
.bullseye-btn {
  padding: 5px 12.5px;
}
.bullseye {
  content: url("../assets/bullseye.png");
}
.share {
  position: absolute;
  top: 10px;
  right: 58px;
  z-index: 1;
  filter: drop-shadow(2px 2px 2px #666);
}
.share.button {
  padding: 5px 10px;
}
</style>


<style lang="scss">
#logistics-order-map {
  .leaflet-popup-content img {
    border-radius: 8px;
    box-shadow: 0px 0px 1px black;
  }
  .purple-stop {
    height: 18px;
    width: 18px;
    border-radius: 50%;
    filter: drop-shadow(2px 2px 2px #555);
    background-color: magenta;
    opacity: 0.9;
    border-style: solid;
    border-width: 1px;
    border-color: darkslategrey;
    /* animation: shadow-pulse 1s 999; */
  }
  .siilor-stop {
    height: 12px;
    width: 12px;
    opacity: 0.8;
    background-color: lightgreen;
  }
  .songthaew-stop {
    height: 12px;
    width: 12px;
    opacity: 0.8;
    background-color: red;
  }
  .publictuk-stop {
    height: 12px;
    width: 12px;
    opacity: 0.8;
    background-color: cyan;
  }
  .dropoff-point {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    /* transform: translateX(-50%) translateY(-50%); */
    filter: drop-shadow(2px 2px 2px #555);
    background-color: rgb(0, 89, 255);
    border-style: solid;
    border-width: 0.5px;
    border-color: grey;
    animation: shadow-pulse 1s 999;
  }
  .pickup-point {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    /* transform: translateX(-50%) translateY(-50%); */
    filter: drop-shadow(2px 2px 2px #555);
    background-color: lightgreen;
    border-style: solid;
    border-width: 0.5px;
    border-color: grey;
    animation: shadow-pulse 1s 999;
  }
  @keyframes shadow-pulse {
    0% {
      box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
    }
    100% {
      box-shadow: 0 0 0 10px rgba(247, 211, 8, 0);
    }
  }
  .driver-circle {
    /* for passenger */
    height: 43px;
    width: 43px;
    border-radius: 50%;
    padding: 4px;
    transform: translateX(-50%) translateY(-50%);
    filter: drop-shadow(2px 2px 2px #555);
    background-color: rgba(255, 255, 0, 0.651);
    // border-style: solid;
    // border-width: 0.5px;
    // border-color: grey;
    border: 0.5px solid grey;
    animation: shadow-pulse 1s 999;
  }
  .cyan-bg {
    /* for driver */
    background-color: cyan;
  }
  .opaque-bg {
    height: 30px;
    width: 30px;
    background-color: rgba(255, 255, 255, 0.7);
    border-width: 0px;
  }
  .available-bg {
    height: 30px;
    width: 30px;
    // background-color: rgba(159, 255, 155, 0.7);
    background-color: palegreen;
    border-width: 0px;
  }
  .busy-bg {
    height: 30px;
    width: 30px;
    background-color: rgba(255, 94, 201, 0.7);
    border-width: 0px;
  }
  .driver-small {
    height: 20px;
    width: 20px;
    filter: drop-shadow(0px 0px 1px #555);
  }
  .driver-big {
    height: 30px;
    width: 30px;
    filter: drop-shadow(0px 0px 1px #555);
  }
  .none {
    /* empty on purpose to hide small white box under divIcon */
  }
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
  }
}
</style>